import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../Components/baseUrl";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";
import CallModal from "../../Components/CallModal";
import FactorDescription from "../../Components/FactorDescription";
import PrintModal from "../../Components/PrintModal";
import { useReactToPrint } from "react-to-print";
import Menu from "../../Components/Menu";
import ConfirmModal from "../../Components/ConfirmModal";
import Map, { GeolocateControl, Marker } from "react-map-gl";
import "mapbox-gl/dist/mapbox-gl.css";

const ShowFactor = () => {
    const navigate = useNavigate();
    let token;
    let user;

    const [selectedLocation, setSelectedLocation] = useState(null);
    const [activeUser, setActiveUser] = useState([]);
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
        user = localStorage.getItem("user");
    }
    useEffect(() => {
        document.title = "پایا | فاکتور";
        token == null && navigate("/login", { replace: true });
        setActiveUser(JSON.parse(user));
    }, []);
    const { factorId } = useParams();
    const [list, setList] = useState([]);
    const [customer, setCustomer] = useState([]);
    const [products, setProducts] = useState([]);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const factorHandler = () => {
        let config = {
            url: `${baseUrl}/orders/${factorId}/show`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                setList(res.data.data);
                setCustomer(res.data.data.customer);
                setProducts(res.data.data.products);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const getLocation = () => {
        let config = {
            url: `${baseUrl}/orders/${factorId}/distributor-location`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                // setSelectedLocation(res.data.data.products);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    useEffect(() => {
        factorHandler();
        getLocation();
    }, []);
    const [phoneNumber, setPhoneNumber] = useState("");
    const [showCallModal, setShowCallModal] = useState(false);
    const [showDesModal, setShowDesModal] = useState(false);

    const refP = useRef(null);

    const handlePrint = useReactToPrint({
        content: () => refP.current,
    });

    const payHandler = (e) => {
        navigate("/panel/payment/" + factorId);
    };

    const cancleHandler = (e) => {
        let config2 = {
            url: `${baseUrl}/orders/${factorId}/confirm-cancel?status=cancel`,
            method: "GET",
        };
        axios(config2)
            .then((res) => {
                toast.success("با موفقیت لغو شد", {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
                setTimeout(() => {
                    navigate("/panel/orders/new_orders");
                }, 2000);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    const confirmHandler = () => {
        setShowConfirmModal(true);
    };

    const showLocHandler = () => {};
    return (
        <div className="container">
            {(showCallModal || showDesModal || showConfirmModal) && (
                <div
                    onClick={() => {
                        setShowCallModal(false);
                        setShowDesModal(false);
                        setShowConfirmModal(false);
                    }}
                    id="bg_gray"
                    className="bg-gray"
                ></div>
            )}{" "}
            {showCallModal && <CallModal phone={phoneNumber} />}
            {showDesModal && (
                <FactorDescription
                    setShow={setShowDesModal}
                    factorId={factorId}
                />
            )}
            {showConfirmModal && (
                <ConfirmModal item={list} setShow={setShowConfirmModal} />
            )}
            <div ref={refP}>
                <PrintModal item={list} />
            </div>
            <div className="new-fac-main">
                <div className="pay-fac-head">
                    <div className="svg-divs">
                        {list && list.length !== 0 && (
                            <svg
                                onClick={handlePrint}
                                className="ml-23"
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M7.25 7H16.75V5C16.75 3 16 2 13.75 2H10.25C8 2 7.25 3 7.25 5V7Z"
                                    stroke="#292D32"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M16 15V19C16 21 15 22 13 22H11C9 22 8 21 8 19V15H16Z"
                                    stroke="#292D32"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M21 10V15C21 17 20 18 18 18H16V15H8V18H6C4 18 3 17 3 15V10C3 8 4 7 6 7H18C20 7 21 8 21 10Z"
                                    stroke="#292D32"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M17 15H15.79H7"
                                    stroke="#292D32"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M7 11H10"
                                    stroke="#292D32"
                                    strokeWidth="1.5"
                                    strokeMiterlimit="10"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        )}
                        {/* {activeUser.type &&
                            activeUser.type !== "visitor" &&
                            (list.Status == "سفارش جدید" ||
                                list.Status == "ارسال به مشتری" ||
                                list.Status == "ارسال به انبار") && (
                                <svg
                                    onClick={payHandler}
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M14.5 16H9.5"
                                        stroke="#292D32"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M12.9 2.52009L12.87 2.59009L9.96995 9.32009H7.11995C6.43995 9.32009 5.78995 9.46009 5.19995 9.71009L6.94995 5.53009L6.98995 5.43009L7.05995 5.27009C7.07995 5.21009 7.09995 5.15009 7.12995 5.10009C8.43995 2.07009 9.91995 1.38009 12.9 2.52009Z"
                                        stroke="#292D32"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M18.29 9.52002C17.84 9.38002 17.36 9.32002 16.88 9.32002H9.96997L12.87 2.59002L12.9 2.52002C13.05 2.57002 13.19 2.64002 13.34 2.70002L15.55 3.63002C16.78 4.14002 17.64 4.67002 18.16 5.31002C18.26 5.43002 18.34 5.54002 18.41 5.67002C18.5 5.81002 18.57 5.95002 18.61 6.10002C18.65 6.19002 18.68 6.28002 18.7 6.36002C18.97 7.20002 18.81 8.23002 18.29 9.52002Z"
                                        stroke="#292D32"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M12 22.0001H8.1C7.86 22.0001 7.62 21.9801 7.39 21.9501C4.21 21.7401 2.51 20.0401 2.3 16.8601C2.27 16.6301 2.25 16.3901 2.25 16.1501V14.2001C2.25 12.1901 3.47 10.4601 5.21 9.71007C5.81 9.46007 6.45 9.32007 7.13 9.32007H16.89C17.38 9.32007 17.86 9.39007 18.3 9.52007C20.3 10.1201 21.76 11.9901 21.76 14.1901V16.1401C21.76 16.3401 21.75 16.5401 21.74 16.7401C21.55 20.2401 19.6 22.0001 15.9 22.0001"
                                        stroke="#292D32"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M6.94999 5.53003L5.19999 9.71003C3.45999 10.46 2.23999 12.19 2.23999 14.2V11.27C2.23999 8.43003 4.25999 6.06003 6.94999 5.53003Z"
                                        stroke="#292D32"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M21.76 11.2701V14.2001C21.76 12.0001 20.3 10.1301 18.3 9.5301C18.82 8.2301 18.97 7.2101 18.72 6.3601C18.7 6.2701 18.67 6.1801 18.63 6.1001C20.49 7.0601 21.76 9.0301 21.76 11.2701Z"
                                        stroke="#292D32"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            )} */}
                    </div>
                    <span className="title"></span>
                    <div></div>
                </div>
                {customer && (
                    <h1>
                        {customer.name} {customer.family}({customer.store_name}){" "}
                    </h1>
                )}
                <span className="time"> {list && list.Created_at} </span>
                {products &&
                    products.length !== 0 &&
                    products.map((item) => {
                        return (
                            <div key={item.id} className="new-fac-card">
                                <div className="d-flex-center">
                                    <img src={item.image} alt="" />
                                    <div>
                                        <span className="name">
                                            {item.name}
                                        </span>
                                        <span className="price">
                                            قیمت واحد :{" "}
                                            {Number(
                                                item.unit_price
                                            ).toLocaleString()}
                                        </span>
                                        <span className="all-p">
                                            جمع کل :{" "}
                                            {Number(
                                                item.total_payment_with_gift
                                            ).toLocaleString()}
                                        </span>
                                    </div>
                                </div>

                                <div className="acts">
                                    <div className="box-num">
                                        <span>{item.measure_unit}</span>
                                        <div className="blue-cir">
                                            {item.order_count}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
                {list.gifts &&
                    list.gifts.length !== 0 &&
                    list.gifts.map((i) => {
                        return (
                            <>
                                <div className="new-fac-card">
                                    <span>{i.product.name}</span>
                                    <span>
                                        {i.count} {i.product.measure_unit}
                                    </span>
                                    <span>
                                        {" "}
                                        {Number(
                                            i.product.unit_price * i.count
                                        ).toLocaleString()}{" "}
                                        تومان
                                    </span>
                                </div>
                            </>
                        );
                    })}
                {list && (
                    <div className="new-fac-card d-block">
                        <div className="fac-row">
                            <span className="span-1"> تحصیلدار(موضع) </span>
                            <div className="pelak justify-content-center">
                                {/* <div className="right">44</div>
                            <div className="left">
                                <span>22</span>
                                <span>ب</span>
                                <span>147</span>
                            </div> */}
                                <div className="left justify-content-center px-0">
                                    {list.distributor &&
                                        list.distributor.car_number}
                                </div>
                            </div>
                        </div>
                        <div className="fac-row mt-10">
                            <span className="name">
                                {list.distributor &&
                                    list.distributor.name +
                                        " " +
                                        list.distributor &&
                                    list.distributor.family}
                            </span>
                            <div className="car">
                                <svg
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M15 3V12C15 13.1 14.1 14 13 14H2V6C2 3.79 3.79 2 6 2H14C14.55 2 15 2.45 15 3Z"
                                        fill="#3BA7E4"
                                    />
                                    <path
                                        opacity="0.4"
                                        d="M22 14V17C22 18.66 20.66 20 19 20H18C18 18.9 17.1 18 16 18C14.9 18 14 18.9 14 20H10C10 18.9 9.1 18 8 18C6.9 18 6 18.9 6 20H5C3.34 20 2 18.66 2 17V14H13C14.1 14 15 13.1 15 12V5H16.84C17.56 5 18.22 5.39001 18.58 6.01001L20.29 9H19C18.45 9 18 9.45 18 10V13C18 13.55 18.45 14 19 14H22Z"
                                        fill="#3BA7E4"
                                    />
                                    <path
                                        d="M8 22C9.10457 22 10 21.1046 10 20C10 18.8954 9.10457 18 8 18C6.89543 18 6 18.8954 6 20C6 21.1046 6.89543 22 8 22Z"
                                        fill="#3BA7E4"
                                    />
                                    <path
                                        d="M16 22C17.1046 22 18 21.1046 18 20C18 18.8954 17.1046 18 16 18C14.8954 18 14 18.8954 14 20C14 21.1046 14.8954 22 16 22Z"
                                        fill="#3BA7E4"
                                    />
                                    <path
                                        d="M22 12.53V14H19C18.45 14 18 13.55 18 13V10C18 9.45 18.45 9 19 9H20.29L21.74 11.54C21.91 11.84 22 12.18 22 12.53Z"
                                        fill="#3BA7E4"
                                    />
                                </svg>
                                <span>
                                    {list.distributor &&
                                        list.distributor.car_name}
                                </span>
                                <svg
                                    onClick={showLocHandler}
                                    width="24"
                                    height="24"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M15.1199 10.3099C15.1199 12.0299 13.7299 13.4299 11.9999 13.4299C10.2699 13.4299 8.87988 12.0399 8.87988 10.3099C8.87988 8.57994 10.2799 7.18994 11.9999 7.18994C12.3399 7.18994 12.6699 7.23994 12.9699 7.33994"
                                        stroke="#0085FF"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                    <path
                                        d="M5.97996 4.30006C10.35 0.190061 18.82 1.60006 20.38 8.51006C21.53 13.5901 18.37 17.8901 15.6 20.5501C13.59 22.4901 10.41 22.4901 8.38996 20.5501C5.62996 17.8801 2.45996 13.5801 3.61996 8.50006"
                                        stroke="#0085FF"
                                        strokeWidth="1.5"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                            </div>
                        </div>
                        <div className="fac-row mt-10 row-btns">
                            <button
                                onClick={(e) => {
                                    setPhoneNumber(
                                        list.distributor &&
                                            list.distributor.mobile
                                    );
                                    setShowCallModal(true);
                                }}
                                className="call-btn"
                            >
                                <svg
                                    width="17"
                                    height="17"
                                    viewBox="0 0 17 17"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M6.65133 4.25717C6.77883 4.43425 6.87091 4.59716 6.93466 4.753C6.99841 4.90175 7.03383 5.0505 7.03383 5.18508C7.03383 5.35508 6.98425 5.52508 6.88508 5.688C6.793 5.85091 6.65841 6.02091 6.48841 6.19091L5.95008 6.7505C5.87216 6.82841 5.83675 6.9205 5.83675 7.03383C5.83675 7.0905 5.84383 7.14008 5.858 7.19675C5.87925 7.25341 5.9005 7.29591 5.91466 7.33841C6.04216 7.57216 6.26175 7.87675 6.57341 8.24508C6.89216 8.61342 7.23216 8.98883 7.6005 9.36425C7.983 9.73967 8.35133 10.0867 8.72675 10.4055C9.09508 10.7172 9.39966 10.9297 9.6405 11.0572C9.67591 11.0713 9.71841 11.0926 9.768 11.1138C9.82466 11.1351 9.88133 11.1422 9.94508 11.1422C10.0655 11.1422 10.1576 11.0997 10.2355 11.0217L10.7738 10.4905C10.9509 10.3134 11.1209 10.1788 11.2838 10.0938C11.4467 9.99467 11.6097 9.94508 11.7867 9.94508C11.9213 9.94508 12.063 9.97342 12.2188 10.0372C12.3747 10.1009 12.5376 10.193 12.7147 10.3134L15.0592 11.978C15.2434 12.1055 15.3709 12.2542 15.4488 12.4313C15.5197 12.6084 15.5622 12.7855 15.5622 12.9838C15.5622 13.2388 15.5055 13.5009 15.3851 13.7559C15.2647 14.0109 15.1088 14.2517 14.9034 14.4784C14.5563 14.8609 14.1738 15.1372 13.7417 15.3142C13.3167 15.4913 12.8563 15.5834 12.3605 15.5834C11.638 15.5834 10.8659 15.4134 10.0513 15.0663C9.23675 14.7192 8.42216 14.2517 7.61466 13.6638C6.80008 13.0688 6.028 12.4101 5.29133 11.6805C4.56175 10.9438 3.903 10.1717 3.31508 9.36425C2.73425 8.55675 2.26675 7.74925 1.92675 6.94883C1.58675 6.14133 1.41675 5.36925 1.41675 4.63258C1.41675 4.15091 1.50175 3.6905 1.67175 3.2655C1.84175 2.83341 2.11091 2.43675 2.48633 2.08258C2.93966 1.63633 3.4355 1.41675 3.95966 1.41675C4.158 1.41675 4.35633 1.45925 4.53341 1.54425C4.71758 1.62925 4.8805 1.75675 5.008 1.94091"
                                        stroke="#419B44"
                                        strokeWidth="1.5"
                                        strokeMiterlimit="10"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    />
                                </svg>
                                <span>تماس تلفنی</span>
                            </button>
                            <div className="time-alert">
                                <svg
                                    width="17"
                                    height="19"
                                    viewBox="0 0 17 19"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M2.26296 15.1667C1.46523 13.9749 1 12.5418 1 11C1 6.85786 4.35786 3.5 8.5 3.5C12.6421 3.5 16 6.85786 16 11C16 15.1421 12.6421 18.5 8.5 18.5C7.0041 18.5 5.61048 18.0621 4.44038 17.3074"
                                        stroke="#F2994A"
                                        strokeWidth="0.8"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M6.83325 1H10.1666"
                                        stroke="#F2994A"
                                        strokeWidth="0.8"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M8.5 1L8.5 3.5"
                                        stroke="#F2994A"
                                        strokeWidth="0.8"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M8.5 11L11 8.5"
                                        stroke="#F2994A"
                                        strokeWidth="0.8"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M13.9167 5.16667L14.3334 4.75"
                                        stroke="#F2994A"
                                        strokeWidth="0.8"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                <span className="span-time">
                                    {list.delivery_time}
                                </span>
                            </div>
                        </div>
                    </div>
                )}
                <div className="description">
                    {activeUser.type &&
                        activeUser.type !== "visitor" &&
                        list.Status == "سفارش جدید" && (
                            <div
                                className="des-text-rel"
                                onClick={() => setShowDesModal(true)}
                            >
                                <svg
                                    width="22"
                                    height="21"
                                    viewBox="0 0 22 21"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <path
                                        d="M11 20.9587C10.3962 20.9587 9.8275 20.6525 9.425 20.1187L8.1125 18.3687C8.08625 18.3337 7.98125 18.29 7.9375 18.2812H7.5C3.85125 18.2812 1.59375 17.2925 1.59375 12.375V8C1.59375 4.1325 3.6325 2.09375 7.5 2.09375H14.5C18.3675 2.09375 20.4062 4.1325 20.4062 8V12.375C20.4062 16.2425 18.3675 18.2812 14.5 18.2812H14.0625C13.9925 18.2812 13.9313 18.3162 13.8875 18.3687L12.575 20.1187C12.1725 20.6525 11.6038 20.9587 11 20.9587ZM7.5 3.40625C4.3675 3.40625 2.90625 4.8675 2.90625 8V12.375C2.90625 16.33 4.2625 16.9688 7.5 16.9688H7.9375C8.38375 16.9688 8.89125 17.2225 9.1625 17.5813L10.475 19.3313C10.7812 19.7338 11.2188 19.7338 11.525 19.3313L12.8375 17.5813C13.1263 17.1963 13.5813 16.9688 14.0625 16.9688H14.5C17.6325 16.9688 19.0938 15.5075 19.0938 12.375V8C19.0938 4.8675 17.6325 3.40625 14.5 3.40625H7.5Z"
                                        fill="#0085FF"
                                    />
                                    <path
                                        d="M11 7V13"
                                        stroke="#0085FF"
                                        strokeLinecap="round"
                                    />
                                    <path
                                        d="M14 10L8 10"
                                        stroke="#0085FF"
                                        strokeLinecap="round"
                                    />
                                </svg>
                                ثبت توضیحات
                            </div>
                        )}
                    {list && (
                        <div className="des-table">
                            <hr />
                            <div className="des-row">
                                <div className="des-span-1">تخفیف سفارشی</div>
                                <div className="des-span-2 text-red">
                                    {list.gifted_value} تومان
                                </div>
                            </div>
                            <hr />
                            <div className="des-row">
                                <div className="des-span-1">
                                    طلب جمع مبلغ با حساب قبلی
                                </div>
                                <div className="des-span-2 text-red">
                                    {list.final_value_with_previous_account}
                                </div>
                            </div>
                            <hr />
                            <div className="des-row">
                                <div className="des-span-1">
                                    مبلغ فاکتور با تخفیفات
                                </div>
                                <div className="des-span-2 text-blue">
                                    {Number(
                                        list.final_value_with_gift
                                    ).toLocaleString()}{" "}
                                    تومان
                                </div>
                            </div>
                            {/* <hr />
                            <div className="des-row">
                                <div className="des-span-1">
                                    جمع مبلغ با حساب قبلی
                                </div>
                                <div className="des-span-2 text-red">
                                    500،000 تومان
                                </div>
                            </div> */}
                            <hr />
                            <div className="des-row">
                                <div className="des-span-1">وضعیت فاکتور</div>
                                <div className="des-span-2 text-green">
                                    {list.Status}
                                </div>
                            </div>
                            <hr />
                        </div>
                    )}
                </div>
                {activeUser.type && activeUser.type !== "visitor" ? (
                    <>
                        {list.Status == "سفارش جدید" ? (
                            <div className="pay-factor-btns">
                                <button
                                    className="pay-factor-btn return-btn"
                                    onClick={cancleHandler}
                                >
                                    لغو
                                </button>
                                <button
                                    className="pay-factor-btn"
                                    onClick={() => {
                                        navigate(
                                            "/panel/edit_order/" + factorId
                                        );
                                    }}
                                >
                                    ویرایش
                                </button>
                            </div>
                        ) : list.Status == "ارسال به مشتری" ||
                          list.Status == "ارسال به انبار" ? (
                            <div className="pay-factor-btns">
                                {/* <button
                                    className="pay-factor-btn return-btn"
                                    onClick={(e) => {
                                        navigate("/panel/return/" + factorId);
                                    }}
                                >
                                    کالای برگشتی
                                </button> */}
                                {/* <button
                                    className="pay-factor-btn"
                                    onClick={confirmHandler}
                                >
                                    تایید فاکتور
                                </button> */}
                            </div>
                        ) : list.Status == "تایید شده" ? (
                            <div className="pay-factor-btns">
                                <button
                                    className="pay-factor-btn return-btn"
                                    onClick={(e) => {
                                        navigate("/panel/return/" + factorId);
                                    }}
                                >
                                    مرجوعی
                                </button>
                            </div>
                        ) : (
                            ""
                        )}
                    </>
                ) : (
                    <>
                        {list.Status == "سفارش جدید" ? (
                            <div className="pay-factor-btns">
                                <button
                                    className="pay-factor-btn return-btn"
                                    onClick={cancleHandler}
                                >
                                    لغو
                                </button>
                                <button
                                    className="pay-factor-btn"
                                    onClick={() => {
                                        navigate(
                                            "/panel/edit_order/" + factorId
                                        );
                                    }}
                                >
                                    ویرایش
                                </button>
                            </div>
                        ) : list.Status == "ارسال به مشتری" ||
                          list.Status == "ارسال به انبار" ? (
                            <div className="pay-factor-btns"></div>
                        ) : list.Status == "تایید شده" ? (
                            <div className="pay-factor-btns">
                                <button
                                    className="pay-factor-btn return-btn"
                                    onClick={(e) => {
                                        navigate("/panel/return/" + factorId);
                                    }}
                                >
                                    مرجوعی
                                </button>
                            </div>
                        ) : (
                            ""
                        )}
                    </>
                )}
                <Menu active="cart" />
            </div>
        </div>
    );
};

export default ShowFactor;
